import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { selectFilters } from "slices/captureDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/notifications";

export const fetchCaptureNotifications = createAsyncThunk(
  "captureNotificationsWidget/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);
